import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';
import { tagTypes } from 'store';

export const api = createApi({
  reducerPath: 'api',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
  tagTypes: tagTypes,
});
